import { render } from "./ConfiguracaoDeTrecho.vue?vue&type=template&id=55d52c7e"
import script from "./ConfiguracaoDeTrecho.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoDeTrecho.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bhfagundes/Desktop/mobs2/operacoes-front-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__